import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled from 'styled-components';
import { Checkbox } from '../../Checkbox';
import { TableCell } from '../TableCell';
import { TABLE_CHECKBOX_CELL_WIDTH } from './constants';
import { color, getComponentOverride } from '../../../system';
export var TableCheckboxCellRoot = styled(TableCell)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    cursor: pointer;\n    width: ", "px;\n    &:hover {\n        background-color: ", ";\n    }\n    ", ";\n"])), TABLE_CHECKBOX_CELL_WIDTH, color('primary.lightest'), getComponentOverride('TableCheckboxCell'));
export var TableCheckboxCellCheckbox = styled(Checkbox)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: block;\n    margin-top: 2px;\n"])));